import { useIntl } from 'react-intl';
import { generatePath } from 'react-router';

import { css } from '@sorare/css';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconBug } from '#src/atoms/icons/system/iconBug.ts';
import { iconFile } from '#src/atoms/icons/system/iconFile.ts';
import { iconHelpCircle } from '#src/atoms/icons/system/iconHelpCircle.ts';
import { iconInfoCircle } from '#src/atoms/icons/system/iconInfoCircle.ts';
import { iconList } from '#src/atoms/icons/system/iconList.ts';
import { iconQuoteLeft } from '#src/atoms/icons/system/iconQuoteLeft.ts';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import {
  NavItem,
  Separator,
} from '#src/components/navigation/NavItem/index.tsx';
import {
  BLOG_SPORT,
  GAME_RULES,
  HELP,
  LEGAL_NOTICE,
  TERMS_AND_CONDITIONS,
} from '#src/constants/__generated__/routes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';
import { navLabels } from '#src/lib/glossary.ts';
import { sportToBlogSportMap } from '#src/lib/routing.tsx';

import { Footer } from './Footer/index.tsx';

const root = css`
  border-radius: var(--intermediate-unit);
  background-color: var(--c-surface-background);
`;

type Props = { onClick?: () => void; noFooter?: boolean };
export const MoreNavItems = ({ onClick, noFooter }: Props) => {
  const { formatMessage } = useIntl();
  const { isFlutterApp, postMessage } = useIsMobileApp();
  const {
    flags: { isSorareInternal = false },
  } = useFeatureFlags();
  const { sport: currentSport } = useSportContext();

  return (
    <Vertical className={root} gap={0.5} onClick={onClick}>
      {!!isFlutterApp && !!isSorareInternal && (
        <NavItem
          icon={() => <FontAwesomeIcon icon={iconBug} />}
          label={formatMessage(navLabels.mobileDebugScreen)}
          onClick={() => {
            postMessage('debugScreen', {});
          }}
        />
      )}
      <NavItem
        icon={() => <FontAwesomeIcon icon={iconQuoteLeft} />}
        label={formatMessage(navLabels.blog)}
        to={generatePath(BLOG_SPORT, {
          sport: sportToBlogSportMap[currentSport],
        })}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={iconHelpCircle} />}
        label={formatMessage(navLabels.help)}
        to={HELP}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={iconInfoCircle} />}
        label={formatMessage(navLabels.gameRules)}
        to={GAME_RULES}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={iconList} />}
        label={formatMessage(navLabels.terms)}
        to={TERMS_AND_CONDITIONS}
      />
      <NavItem
        icon={() => <FontAwesomeIcon icon={iconFile} />}
        label={formatMessage(navLabels.legalNotice)}
        to={LEGAL_NOTICE}
      />
      {!noFooter && (
        <>
          <Horizontal className="w-full px-1 pt-1 pb-0.5">
            <Separator />
          </Horizontal>
          <Footer copyrightWrapped />
        </>
      )}
    </Vertical>
  );
};
